module.exports = __webpack_public_path__ + "static/media/ios-heart.70501ebb.svg";